import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";

import SandImage from "./sand.svg?url";
import { WeHaveSoMuchForYouItem } from "./we-have-so-much-for-you-item";

export const Container = styled.div`
  position: relative;

  padding-block: 41px 7.6%;
  padding-inline: 20px;

  &::after {
    position: absolute;
    inset-block-end: 0;
    inset-inline-start: 0;
    content: "";

    display: block;

    inline-size: 100%;
    padding-block-end: 7.6%;

    background-image: url(${SandImage});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-start: 47px;
  }
`;

export const Header = styled(Heading)`
  margin-block-end: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 24px;
  }
`;

export const Description = styled.div`
  margin-block-end: 56px;

  color: #333333;
  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const StyledWeHaveSoMuchForYouItem = styled(WeHaveSoMuchForYouItem)`
  max-inline-size: 280px;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 464px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 280px;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-block-end: 40px;

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-direction: row;
    align-items: flex-start;

    padding-block-end: 64px;
  }

  ${StyledWeHaveSoMuchForYouItem} {
    &:not(&:last-child) {
      margin-block-end: 40px;

      ${props => props.theme.breakpoints.up("desktop")} {
        margin-block-end: 0;
        margin-inline-end: 40px;
      }
    }
  }
`;
